import React from 'react'
import { IView } from '../../types/views'
import { isHidden } from '../../services/views'

export const View = ({
  keep,
  notFullHeight,
  children,
  className = '',
  ...props
}: IView) => {
  const generatedClassName = isHidden(props)
    ? 'hidden'
    : `${notFullHeight ? '' : 'full-height'} auto-visible`
  return keep ? (
    <div className={`${className && `${className} `}${generatedClassName}`}>
      {children}
    </div>
  ) : (
    !isHidden(props) && children
  )
}
